import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import YouTube from 'react-youtube'
import getYouTubeID from 'get-youtube-id'

// CSS
import './WorkElement.css'

class WorkElement extends Component {

  static propTypes = {
    project: PropTypes.object.isRequired,
  }

  render() {

    if(this.props.project.video) {
        return (
            <li className={`work-overview-item ${this.props.project.highlight ? 'highlight' : ''}`}>
                <div className="videoWrapper">
                    <YouTube
                        videoId={getYouTubeID(this.props.project.video)}
                        opts={
                            {
                                playerVars: {
                                    fs: 0,
                                    modestbranding: 0,
                                    rel: 0,
                                    showinfo: 0
                                }
                            }
                        }
                    />
                </div>
                <Link to={'/work/' + this.props.project.url}>
                    <span className="project-title">{this.props.project.title}</span>
                </Link>
            </li>
        )
    }

    if(this.props.project.cover_image) {
        return (
            <li className={`work-overview-item ${this.props.project.highlight ? 'highlight' : ''}`}>
                <Link to={'/work/' + this.props.project.url}>
                    <img className="project-image" src={this.props.project.cover_image} alt={this.props.project.title} />
                    <span className="project-title">{this.props.project.title}</span>
                </Link>
            </li>
        )
    } 

    return null
    
  }
}

export default WorkElement;


// WEBPACK FOOTER //
// ./src/components/main/work/workoverview/workelement/WorkElement.js